import { BrowserTracing } from '@sentry/browser';

// Sentry
import * as Sentry from '@sentry/vue';
import Axios from 'axios';
// VeeValidate.localize(dictionary);
// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import dateFnsLocalePl from 'date-fns/locale/pl';
import _ from 'lodash';
//Vue use Click out side element
import vClickOutside from 'v-click-outside';
import { VueMaskDirective } from 'v-mask';
// VeeValidate
import VeeValidate, { Validator } from 'vee-validate';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
//------------VUE TIMEAGO CONFIG----------------
import VueTimeago from 'vue-timeago';
// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer';
//----------DATEPICKER CONFIG-------------------
import Datepicker from 'vuejs-datepicker';
// Vuesax Component Framework
import Vuesax from 'vuesax';
import Api from '../api-v2';
import HubAbortControllerProvider from '../providers/HubAbortControllerProvider.js';
//Filter file
import '../src/filters/filters';
// Theme Configurations
import '../themeConfig.js';
import App from './App.vue';
import axios from './axios';
//---------------TABS CONFIG--------------------
import hubTabs from './components/tabs/hubTabs';

// Globally Registered Components
import './globalComponents.js';
import breadcrumbs from './mixins/breadcrumbs';
import format from './mixins/format';
import pagination from './mixins/pagination';
//global mixins - use with caution!
import validation from './mixins/validation';

// Vue Router
import router from './router';
// Vuex Store
import store from './store/store';
import { registerValidationRules } from './validation-rules';
import pl from './validation/lang/pl';

window._ = _;
window.hubAbortControllerProviderInstance = new HubAbortControllerProvider();

window.hubAppEnvConfig = {
  MIX_ADMIN_PARENT: import.meta.env.VITE_ADMIN_PARENT,
  MIX_PUZZLETAX_SIGNER_URL: import.meta.env.VITE_PUZZLETAX_SIGNER_URL,
  MIX_SITE_ENV: import.meta.env.VITE_SITE_ENV,
};

Vue.use(Vuesax);

Vue.prototype.$api = Api;

Vue.prototype.DATE_FORMAT = 'yyyy-MM-dd';
Datepicker.methods.clearDate = function () {
  this.selectedDate = null;
  this.setPageDate();
  this.$emit('selected', null);
  this.$emit('input', null);
  this.$emit('cleared');
};
Datepicker.props.format.default = 'yyyy-MM-dd';
Vue.component('datepicker', {
  extends: Datepicker,
  props: {
    clearButton: {
      type: Boolean,
      default: true,
    },
    typeable: {
      type: Boolean,
      default: true,
    },
    clearButtonIcon: {
      type: String,
      default: 'feather icon-x',
    },
  },
});
// ---------------------------------------------

Vue.component('vs-tabs', hubTabs);
//----------------------------------------------

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'pl-PL',
  locales: {
    'pl-PL': dateFnsLocalePl,
  },
});
//----------------------------------------------

Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    Vue,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local',
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: (import.meta.env.VITE_SENTRY_TRACING_ORIGINS || '').split(','),
      }),
    ],
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '1.0') || 1.0,
  });
}

window.axios = axios;

Vue.use(VueHammer);

Vue.use(vClickOutside);

Vue.directive('mask', VueMaskDirective);

Validator.localize('pl', pl);
Validator.localize('pl', {
  messages: {
    confirmed: (e, n) => `Pole ${ e } nie zgadza się z polem ${ n[0] }`,
  },
});

Validator.extend('hub_decimal_positive_number', {
  getMessage: field => 'Pole ' + field + ' nie może mieć ujemnej wartości.',
  validate: value => {
    if (null === value || undefined === value || '' === value) {
      return true;
    }

    switch (typeof value) {
      case 'number':
        return true;
      case 'string':
        return /^\d+(\ \d+)*([\.\,]\d+)?$/.test(value.trim());
    }
    return false;
  },
});

Vue.use(VeeValidate, {
  locale: 'pl',
});

// Register custom validation rules
registerValidationRules(Validator);

window.hubIntlNumberFormat = new Intl.NumberFormat('pl-PL', {
  useGrouping: true,
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
window.hubNoFractionIntlNumberFormat = new Intl.NumberFormat('pl-PL', {
  useGrouping: true,
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
Vue.config.productionTip = false;

VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

Vue.mixin(validation);
Vue.mixin(breadcrumbs);
Vue.mixin(format);
Vue.mixin(pagination);

// GTM — jednorazowa inicjalizacja
const gtmId = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID;
if (gtmId) {
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + gtmId;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', gtmId);
}

// Hotjar — jednorazowa inicjalizacja
const hotjarId = import.meta.env.VITE_HOTJAR_ID;
if (hotjarId) {
  (function (h, o, t, j, a, r) {
    h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments); };
    h._hjSettings = { hjid: hotjarId, hjsv: 6 };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + hotjarId + j + 6;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

// Facebook Pixel — odpala tylko na /register, obsługuje nawigację SPA
const pixelId = import.meta.env.VITE_PIXEL_ID;
if (pixelId) {
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) { return; }
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) { f._fbq = n; }
    n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', pixelId);

  router.afterEach((to) => {
    if (to.path === '/register') {
      fbq('track', 'PageView');
    }
  });
}

window.hubApp = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

window.onstorage = (e) => {
  if (!store.getters['auth/isLoggedIn']) {
    return;
  }

  if (localStorage.getItem('parent') === null) {
    store.dispatch('auth/logout');
    router.push('/login').catch(() => {});
    return;
  }

  const result = store.state.auth.activeAccountParent !== localStorage.getItem('parent');

  if (store.state.GENERAL.isChangeParentDetected === result) {
    return;
  }

  store.commit('GENERAL/setIsChangeParentDetected', result);

};

console.info(`\n`
  + ` ___ _  _ ___ ___ _   ___ _____ __ __   __\n`
  + `| _,| || |_  |_  | | | __|_   _/  \\\\ \\_/ / \n`
  + `| v_| \\/ |/ / / /| |_| _|  | || /\\ |> , <  \n`
  + `|_|  \\__/|___|___|___|___| |_||_||_/_/ \\_\\ \n`
  + `\n`
  + `W każdym miejscu, o każdej porze\n`
  + `konsola@puzzletax.pl\n`,
);
